import { Component, OnDestroy, OnInit, RendererFactory2 } from '@angular/core';
import { EnvService } from '@services';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'resistmap-reporting';
  private destroy$ = new Subject<void>();

  constructor(private rendererFactory: RendererFactory2, protected env: EnvService) {}

  ngOnInit() {
    this.loadTag();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadTag() {
    const renderer = this.rendererFactory.createRenderer(null, null);
    const script = renderer.createElement('script');
    script.async = true;
    script.innerHTML = `
    var _mtm = window._mtm = window._mtm || [];
    _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
    (function() {
      var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
      g.async=true; g.src='${this.env.environment.tag_url}'; s.parentNode.insertBefore(g,s);
    })();
    `;
    renderer.appendChild(document.head, script);
  }
}
